
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/prompts",
      function () {
        return require("private-next-pages/admin/prompts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/prompts"])
      });
    }
  